import React from 'react';
import PropTypes from 'prop-types';
import Message from 'Components/Modal/Message';
import EnvironmentManager from 'Utils/environmentManager';

const TribunCouponShareFailedModal = props => {

  /*const buttonConfig = {
    primary: {
      label: 'Tamam',
      onClick: props.onPrimaryButtonClick
    }
  };*/

  const eventList = props.data && props.data.length && props.data.map((item, index) => {
    return (
      <div key={ index }>
        <span>{ item.eventName }</span>
        <span>{ item.marketName }</span>
      </div>
    );
  });

  return (
    <Message type="none">
      <span>{ EnvironmentManager.getMessageText({ key: `iddaa-coupons-api${props.errorCode}` }) }</span>
      { eventList }
    </Message>
  );
};

TribunCouponShareFailedModal.propTypes = {
  data: PropTypes.array,
  errorCode: PropTypes.number
};

export default TribunCouponShareFailedModal;
